import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

function About() {
    const navigate = useNavigate();

    const navigateToPolicy = (lang) => {
        navigate(`/privacy-policy-${lang}`);
    };
    const navigateToPolicyLite = (lang) => {
        navigate(`/privacy-policy-Lite-${lang}`);
    };

    return (
        <div className="home-container">
            <h1>Privacy policy Tasbih Dhikr : ...  </h1>
            <div>
                <button onClick={() => navigateToPolicy('ar')}>Arabic</button>
                <button onClick={() => navigateToPolicy('de')}>German</button>
                <button onClick={() => navigateToPolicy('es')}>Spanish</button>
                <button onClick={() => navigateToPolicy('fr')}>French</button>
                <button onClick={() => navigateToPolicy('hi')}>Hindi</button>
                <button onClick={() => navigateToPolicy('id')}>Indonesian</button>
                <button onClick={() => navigateToPolicy('it')}>Italian</button>
                <button onClick={() => navigateToPolicy('ja')}>Japanese</button>
                <button onClick={() => navigateToPolicy('ru')}>Russian</button>
                <button onClick={() => navigateToPolicy('tr')}>Turkish</button>
                <button onClick={() => navigateToPolicy('zh')}>Chinese</button>
            </div>
            <h1>Privacy policy Tasbih Dhikr Lite: ...</h1>
            <div>
                <button onClick={() => navigateToPolicyLite('ar')}>Arabic</button>
                <button onClick={() => navigateToPolicyLite('de')}>German</button>
                <button onClick={() => navigateToPolicyLite('es')}>Spanish</button>
                <button onClick={() => navigateToPolicyLite('en')}>English</button>
                <button onClick={() => navigateToPolicyLite('fr')}>French</button>
                <button onClick={() => navigateToPolicyLite('hi')}>Hindi</button>
                <button onClick={() => navigateToPolicyLite('id')}>Indonesian</button>
                <button onClick={() => navigateToPolicyLite('it')}>Italian</button>
                <button onClick={() => navigateToPolicyLite('ja')}>Japanese</button>
                <button onClick={() => navigateToPolicyLite('ru')}>Russian</button>
                <button onClick={() => navigateToPolicyLite('tr')}>Turkish</button>
                <button onClick={() => navigateToPolicyLite('zh')}>Chinese</button>
            </div>
        </div>
    );
}

export default About;
